import React, { useCallback, useEffect, useState } from "react";
import style from "css/app.module.css";
import alertStyle from "css/menu.module.css";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as Alram } from "asset/header/alram.svg";
import { ReactComponent as User } from "asset/menu/mypage.svg";
import { Cookies } from "react-cookie";
import { insertUserInfo, deleteUserInfo } from "redux/slices/userSlice";
import {
  insertAllowPageInfo,
  deleteAllowPageInfo,
} from "redux/slices/allowPageSlice";
import { useNavigate } from "react-router-dom";
import { Button, ConfigProvider, Modal, Select, Input } from "antd";
import Alrampop from "components/common/alrampop";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { openAlert, openConfirm, closeAlert } from "redux/slices/alertSlice";
import CryptoJS from "crypto-js";

/**
 * 파일명: Header.js
 * 작성자: 권도훈
 * 작성일자: 23.04.06
 * 설명: app Header
 */
function Header({ pageName }) {
  const [isLoading, setIsLoading] = useState(false);
  //selector
  const payload = useSelector((state) => state.user);
  const [userInfo, setUserInfo] = useState({
    name: payload.name,
    id: payload.id,
    zoomId: payload.zoomId,
    password: "",
  });
  const pathName = window.location.pathname;

  const { t, i18n } = useTranslation();
  const languageList = [
    { value: "ko-KR", label: t("LANGUAGE.ko") },
    { value: "en-US", label: t("LANGUAGE.en") },
  ];
  const [selectType, setSelectType] = useState(i18n.language);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [alramopen, setalramopen] = useState(false);
  const { confirm } = Modal;

  const [isOpen, setIsOpen] = useState(false);
  const [isEditPw, setIsEditPw] = useState(false);

  const logoutHandler = () => {
    confirm({
      className: alertStyle.logout_container,
      centered: true,
      title: (
        <p className={alertStyle.logout_title}>{t("LABEL.TITLE.LOGOUT")}</p>
      ),
      icon: (
        <img
          src={
            process.env.REACT_APP_CLIENT_URL + "img/common/modal_icon_green.png"
          }
          alt=""
          className={`${alertStyle.logout_icon} anticon`}
        />
      ),
      content: (
        <p className={alertStyle.logout_content}>
          {t("MESSAGE.LOGOUT_CONFIRM")}
        </p>
      ),
      okText: t("BTN.OK"),
      okType: "dashed",
      okButtonProps: {
        className: alertStyle.ok_btn,
      },
      cancelText: t("BTN.CANCEL"),
      cancelButtonProps: {
        className: alertStyle.cancel_btn,
        type: "dashed",
      },
      onOk() {
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const cookies = new Cookies();

        cookies.remove(authNm, { path: "/", domain: domain });
        cookies.remove(refreshNm, { path: "/", domain: domain });
        dispatch(deleteUserInfo());
        dispatch(deleteAllowPageInfo());
        navigate(process.env.REACT_APP_CLIENT_URL);
      },
    });
  };
  const alramclose = () => {
    setruncount(true);
    setalramopen(false);
  };
  const closealram = useCallback(() => {
    setruncount(true);
    setalramopen(false);
  }, []);

  const openUserModal = () => {
    setUserInfo({
      name: payload.name,
      id: payload.id,
      zoomId: payload.zoomId,
      password: "",
    });
    setIsOpen(true);
  };
  const closeUserModal = () => {
    setUserInfo({});
    setIsOpen(false);
  };
  //refresh user info
  const refreshInfo = () => {
    axios
      .get("/user/refresh/info")
      .then((res) => {
        if (res.status === 200) {
          const memeberInfo = res.data.MEMBER_INFO;

          dispatch(
            insertUserInfo({
              name: memeberInfo.MEMBER_NM,
              id: memeberInfo.MEMBER_ID,
              zoomId: memeberInfo.ZOOM_ID,
            })
          );

          const allowPages = res.data.ALLOW_PAGES;

          dispatch(insertAllowPageInfo({ pages: allowPages }));
        }
      })
      .catch(() => {
        const effectCookies = new Cookies();
        const authNm = process.env.REACT_APP_AUTH_TOKEN;
        const domain = process.env.REACT_APP_DOMAIN;
        const refreshNm = process.env.REACT_APP_REFRESH_TOKEN;
        effectCookies.remove(authNm, { path: "/", domain: domain });
        effectCookies.remove(refreshNm, { path: "/", domain: domain });
        window.location.href = process.env.REACT_APP_CLIENT_URL;
      });
  };
  const editUserInfo = () => {
    let param = {};
    if (userInfo.password === "") {
      param = {
        MEMBER_NM: userInfo.name,
        MEMBER_ID: userInfo.id,
        ZOOM_ID: userInfo.zoomId,
      };
    } else {
      param = {
        MEMBER_NM: userInfo.name,
        MEMBER_ID: userInfo.id,
        ZOOM_ID: userInfo.zoomId,
        MEMBER_PW: CryptoJS.AES.encrypt(
          userInfo.password,
          CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY),
          {
            iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPTO_KEY),
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC,
          }
        ).toString(),
      };
    }

    axios
      .put("/user/info", param)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: "알림",
            content: "사용자 정보가 수정되었습니다.",
            submitEventHandler: () => {
              closeUserModal();
              refreshInfo();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .catch((error) => {
        const obj = {
          title: "알림",
          content: "사용자 정보 수정 중 오류가 발생했습니다.",
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };
  useEffect(() => {
    if (alramopen) {
      window.addEventListener("click", closealram);
      return () => {
        window.removeEventListener("click", closealram);
      };
    }
  }, [alramopen, closealram]);

  const [alramdot, setalramdot] = useState(false);
  const [runcount, setruncount] = useState(true);
  const countalram = useCallback(() => {
    let config = {
      params: {
        TARGET_USER: payload.id,
      },
    };
    axios.get("/alram/countalram", config).then((res) => {
      if (res.status === 200) {
        if (res.data > 0) {
          setalramdot(true);
        } else {
          setalramdot(false);
        }
      }
    });
  }, [payload]);
  useEffect(() => {
    if (runcount) {
      countalram();
      if (payload.id !== "") {
        setruncount(false);
      }
    }
  }, [runcount, countalram, payload]);

  useEffect(() => {
    if (payload.id !== "") {
      setUserInfo({
        name: payload.name,
        id: payload.id,
        zoomId: payload.zoomId,
        password: "",
      });
    }
  }, [payload]);
  return (
    <header className={style.header}>
      {/* <p className={style.header_title}>{pageName}</p> */}
      <p className={style.header_title}>
        {pathName === "/app/mypage/schedule"
          ? t("MENU.내 일정")
          : pathName === "/app/meeting/room"
          ? t("MENU.회의실 현황")
          : t("MENU." + pageName)}
      </p>

      <section className={style.header_section}>
        {/* <p className={style.header_name}>{payload.name}님</p> */}
        <p className={style.header_name}>
          {t("WELCOME", { NAME: payload.name })}
        </p>
        <Select
          // type="short"
          options={languageList}
          value={selectType}
          onChange={(value) => {
            setSelectType(value);
            i18n.changeLanguage(value);
          }}
          style={{ marginLeft: "25px" }}
        />
        <div className={`${style.header_alram} cursor`} onClick={openUserModal}>
          <User />
        </div>
        <Modal
          title="사용자 정보 수정"
          open={isOpen}
          footer={
            <div className={style.user_info_modal}>
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      colorPrimaryHover: "#1cb691",
                      colorPrimaryActive: "#1cb691",
                    },
                  },
                }}
              >
                <Button onClick={closeUserModal}>{t("BTN.CANCEL")}</Button>
              </ConfigProvider>
              <Button
                type="primary"
                onClick={() => {
                  const obj = {
                    title: "알림",
                    content: "사용자 정보를 수정하시겠습니까?",
                    submitEventHandler: () => {
                      editUserInfo();
                      dispatch(closeAlert());
                    },
                  };
                  dispatch(openConfirm(obj));
                }}
                loading={isLoading}
              >
                {t("BTN.SAVE")}
              </Button>
            </div>
          }
          centered
          onCancel={closeUserModal}
        >
          <div className={style.user_info_item_area}>
            <div className={style.user_info_item}>
              <p className={style.user_info_item_title}>이름</p>
              <div>
                <Input
                  className={style.user_info_item_input}
                  type="primary"
                  value={userInfo.name}
                  onChange={(e) => {
                    setUserInfo({
                      ...userInfo,
                      name: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className={style.user_info_item}>
              <p className={style.user_info_item_title}>이메일</p>
              <div>
                <Input
                  className={style.user_info_item_input}
                  type="primary"
                  value={userInfo.id}
                  disabled
                  onChange={(e) => {
                    setUserInfo({
                      ...userInfo,
                      id: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className={style.user_info_item}>
              <p className={style.user_info_item_title}>줌 계정</p>
              <div>
                <Input
                  className={style.user_info_item_input}
                  type="primary"
                  value={userInfo.zoomId}
                  onChange={(e) => {
                    setUserInfo({
                      ...userInfo,
                      zoomId: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className={style.user_info_item}>
              <p className={style.user_info_item_title}>비밀번호</p>
              <div className={style.user_info_item_password}>
                <Input.Password
                  className={style.user_info_item_input}
                  value={userInfo.password}
                  disabled={!isEditPw}
                  visibilityToggle={false}
                  onChange={(e) => {
                    setUserInfo({
                      ...userInfo,
                      password: e.target.value,
                    });
                  }}
                />
                <Button
                  type="primary"
                  onClick={() => setIsEditPw(!isEditPw)}
                  // loading={isLoading}
                >
                  비밀번호 변경
                </Button>
              </div>
            </div>
          </div>
        </Modal>
        <div>
          <div
            className={`${style.header_alram} cursor`}
            onClick={(e) => {
              e.stopPropagation();
              alramopen ? alramclose() : setalramopen(true);
            }}
          >
            {alramdot ? <div className={style.alramdot} /> : <div></div>}

            <Alram />
          </div>
          {alramopen ? (
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <img
                alt=""
                src={
                  process.env.REACT_APP_CLIENT_URL + "img/alram/triangle.png"
                }
                className={style.triangle}
              />
              <Alrampop alrammoff={() => alramclose()} main={false} />
            </div>
          ) : (
            <div />
          )}
        </div>

        <div
          className={`${style.header_logout} cursor`}
          onClick={() => logoutHandler()}
        >
          Logout
        </div>
      </section>
    </header>
  );
}

export default Header;
